// SW-14: the last few client-side errors, kept in memory so a one-click bug
// report can attach them. Nothing leaves the page until the user taps
// "Report a bug" (ui/authView.ts); nothing is persisted.

const MAX = 20;
const recent: string[] = [];

export function recordClientError(message: string): void {
  const line = `${new Date().toISOString()} ${message}`.slice(0, 500);
  recent.push(line);
  if (recent.length > MAX) recent.splice(0, recent.length - MAX);
}

export function recentClientErrors(): string[] {
  return recent.slice();
}

/** Hook the page's uncaught errors and rejections into the buffer. */
export function installClientErrorCapture(target: Window = window): void {
  target.addEventListener("error", (event) => {
    const where = event.filename ? ` (${event.filename}:${event.lineno})` : "";
    recordClientError(`${event.message}${where}`);
  });
  target.addEventListener("unhandledrejection", (event) => {
    const reason = event.reason;
    recordClientError(`unhandled rejection: ${reason instanceof Error ? reason.message : String(reason)}`);
  });
}
